import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { onBeforeMount, ref, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useGettext } from '@jshmrtn/vue3-gettext';
import { Flash } from '@/core/Flash';
import ProductForm from '@/modules/product/components/ProductForm.vue';
import { Product, useProduct } from '@/modules/product/Product';
import { handleLoadError } from '@/core/common';


export default /*@__PURE__*/_defineComponent({
  __name: 'ProductEdit',
  setup(__props) {

const { $gettext } = useGettext();
const route = useRoute();
const router = useRouter();
const product = ref<Product | null>(null);

const load = async () => {
	try {
		const response = await useProduct().get(route.params.id as string);
		if (response) {
			product.value = response;
		}
	} catch (e) {
		handleLoadError(e as Error, 'product.index');
	}
};

watch(route, () => {
	if (route.params.id) {
		load();
	}
});
onBeforeMount(load);

const saved = (u) => {
	product.value = u;
	Flash.success($gettext('Produkten har sparats.'));
};

const cancel = () => {
	router.push({ name: 'product.index' });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ProductForm, {
    "page-title": _unref($gettext)('Redigera produkt'),
    product: product.value,
    onSaved: saved,
    onCancel: cancel
  }, null, 8, ["page-title", "product"]))
}
}

})